module.exports = __webpack_public_path__ + "img/teams-hy-small-user.39caa3b6.svg";